(function ($) {
  Drupal.behaviors.ehProduct = {
    attach: function (context, settings) {
    // Set products background circle color
      $('.eh-product', context).each(function () {
        var element = $(this);
        var color = element.attr('data-bg-color');
        var image = element.find('.product-image a');

        image.css('background-color', color);
        // Remove 'US' string from product price
        element.find('.product-price').text(element.find('.product-price').text().replace(/US/g, ''));
      });
    }
  };
})(jQuery);
